export default props=>{

const jsx = (<div className="this-content">
    <style jsx>{`
.x{
    float:right;
    margin: -25px 5px 0 0;
}


.message1{
    margin: 30px 70px;
    text-align: center;
}
`}</style>
    <div className="x" onClick={props.hide}> &nbsp;<img src="/assets/images2/x_dark.svg" /></div>

    <div className="message1">
        캠스콘 회원가입이 완료되었습니다.<br/>
        로그인 후, 나의 패션 사진을 공유해보세요.
    </div>
</div>);


    return (jsx);
}